import 'rxjs/add/operator/take';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/let';
import 'rxjs/add/observable/of';
import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Store } from '@ngrx/store';
import { Router, CanActivate, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { of } from 'rxjs/observable/of';
import * as fromRoot from '../../state/reducer/core.reducer';
import * as coreActions from '../../state/action/core.actions';
import { StateInteractionService } from '../../service/dynamic';
import { WindowRef } from '../../service/util';
import { DEVICE_INFO, APP_SETTINGS, DeviceInfo } from '../../../modules/ng-express-engine/tokens';
//var md = require('mobile-detect');
//import { DynamicTemplateBuilder } from '../../dynamic/template.builder';

@Injectable()
export class StatePrepareGuard implements CanActivate {
  private isServer = false; 
  private device = 'desktop'; 
  constructor(
    @Inject(PLATFORM_ID) private platformId: string,
    private store: Store<fromRoot.State>,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private winRef: WindowRef,
    private stateInteractionService: StateInteractionService,
    @Inject(APP_SETTINGS) private settings: Object,
    @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo
  ) { 
      this.isServer = isPlatformServer(this.platformId);
      this.ObservableKey = Observable.of(true);
      if (this.deviceInfo.isMobile){
          if (this.deviceInfo.isTablet){
              this.device = "tablet";
          }
          else{
              this.device = "phone";
          }
      }
  }


    private initState(route: string) {
    }


    private ObservableKey:Observable<boolean> = Observable.of(true);

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.ObservableKey;
    }
}    


// WEBPACK FOOTER //
// ./src/angular-engine/engine/state/guard/state.prepare.ts